(function ($, Drupal, drupalSettings, once) {

  'use strict';

  /* Drupal Behavior */
  Drupal.behaviors.retireContactUsForm = {
    attach: function (context, settings) {
      $('.webform-submission-retire-tennessee-contact-form').validate({
        messages: {
          'field_retire_tn_contact_name': 'Name is required.',
          'field_retire_tn_contact_email': 'Email is required.',
          'field_retire_tn_contact_address[address]': 'Street address is required.',
          'field_retire_tn_contact_address[city]': 'Locality/City is required.',
          'field_retire_tn_contact_address[state_province]': 'State/Province is required.',
          'field_retire_tn_contact_address[postal_code]': 'Postal code is required.'
        }
      });
    }
  };

  Drupal.behaviors.retirecontactselectall = {
    attach: function (context, settings) {
      $('.webform-submission-retire-tennessee-contact-form').validate();

      /* CLICK ELEMENTS */
      var $selectAllToggle = $('#edit-field-retire-tn-contact-counties-all', context);

      // Select all toggle (retire contact form).
      $(once('retirecontactselectall', $selectAllToggle)).on('click', function (e) {
        $('#edit-field-retire-tn-contact-counties input[type=checkbox]').prop('checked', $selectAllToggle.is(':checked'));
      });
    }
  };

  Drupal.behaviors.addstateabbr = {
    attach: function (context, settings) {
      $(once('abbraddition', '#edit-field-retire-tn-contact-address-state-province option')).each(
        function (i) {
          if (i > 0) {
            if ($(this).text().indexOf('(') === -1) {
              var str = $(this).text();
              $(this).text(str + ' (' + $(this).attr('value') + ')');
            }
          }
        }
      );
    }
  };
})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
